/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { QueueReport } from './QueueReport';
import {
    QueueReportFromJSON,
    QueueReportFromJSONTyped,
    QueueReportToJSON,
    QueueReportToJSONTyped,
} from './QueueReport';

/**
 * 
 * @export
 * @interface QueueReports
 */
export interface QueueReports  {
    /**
     * 
     * @type {Array<QueueReport>}
     * @memberof QueueReports
     */
    queueReportList?: Array<QueueReport>;
}

/**
 * Check if a given object implements the QueueReports interface.
 */
export function instanceOfQueueReports(value: object): value is QueueReports {
    return true;
}

export function QueueReportsFromJSON(json: any): QueueReports {
    return QueueReportsFromJSONTyped(json, false);
}

export function QueueReportsFromJSONTyped(json: any, ignoreDiscriminator: boolean): QueueReports {
    if (json == null) {
        return json;
    }
    return {
        
              'queueReportList': json['queueReportList'] == null ? undefined : ((json['queueReportList'] as Array<any>).map(QueueReportFromJSON)),
    };
}

export function QueueReportsToJSON(json: any): QueueReports {
    return QueueReportsToJSONTyped(json, false);
}

export function QueueReportsToJSONTyped(value?: QueueReports | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'queueReportList': value['queueReportList'] == null? value['queueReportList']: (value['queueReportList'] as Array<any>).map(QueueReportToJSON),
    };
}


